<template>
  <span class="LoginLabel">
    <slot />
    <span v-html="loginSvg" class="icon" />
  </span>
</template>

<script setup>
import loginSvg from '~/assets/site-nav/login.svg?raw'
</script>

<style scoped>
.LoginLabel {
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-size: var(--font-size-2);
}
.icon {
  display: inline-block;
  margin-left: var(--spacing-1);
  vertical-align: -2px;
}
</style>
